<template>
  <div class="countdown">
    <div v-if="state === 'before'" class="countdown__grid" role="timer">
      <div v-for="(value, i) in parts" :key="i" class="countdown__unit">
        <span class="countdown__value">{{ pad(value) }}</span>
        <span class="countdown__label">{{ labels[i] }}</span>
      </div>
    </div>
    <p v-else class="countdown__message">{{ state === 'live' ? liveText : doneText }}</p>
  </div>
</template>

<script>
export default {
  name: "ConferenceCountdown",
  props: {
    start: {type: String, required: true},
    end: {type: String, required: true},
    labels: {type: Array, default: () => ['Days', 'Hours', 'Minutes', 'Seconds']},
    liveText: {type: String, default: ''},
    doneText: {type: String, default: ''},
  },
  data: () => ({
    now: Date.now(),
    timer: null,
  }),
  computed: {
    startMs() {
      return new Date(this.start).getTime();
    },
    endMs() {
      return new Date(this.end).getTime();
    },
    state() {
      if (this.now < this.startMs) return 'before';
      return this.now <= this.endMs ? 'live' : 'done';
    },
    parts() {
      const total = Math.max(0, Math.floor((this.startMs - this.now) / 1000));
      return [
        Math.floor(total / 86400),
        Math.floor((total % 86400) / 3600),
        Math.floor((total % 3600) / 60),
        total % 60,
      ];
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    pad(n) {
      return n < 10 ? '0' + n : String(n);
    },
  },
};
</script>

<style lang="scss" scoped>
.countdown__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.countdown__unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 8px 14px;
  border: 1px solid rgba(255, 255, 255, .14);
  border-radius: 14px;
  background: rgba(255, 255, 255, .07);
}

.countdown__value {
  font-family: var(--font-display);
  font-size: clamp(2.25rem, 5vw, 3.5rem);
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: #fff;
}

.countdown__label {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: .12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, .7);
}

.countdown__message {
  margin: 0;
  font-family: var(--font-display);
  font-size: 2rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
}

@media (max-width: 400px) {
  .countdown__grid {
    gap: 8px;
  }
  .countdown__unit {
    padding: 14px 4px 10px;
  }
  .countdown__label {
    font-size: 10px;
    letter-spacing: .06em;
  }
}
</style>
